const STATUS_COLORS: Record<string, string> = {
  '--1': 'bg-(--uizz-antd-color-success)',
  '--9': 'bg-(--uizz-antd-color-success)',
  '--10': 'bg-(--uizz-antd-color-success)',
  '--2': 'bg-(--uizz-antd-color-info)',
  '--3': 'bg-(--uizz-antd-color-error)',
  '--4': 'bg-(--uizz-antd-color-error)',
  '--7': 'bg-(--uizz-antd-color-warning)',
  'paid': 'bg-(--uizz-antd-color-success)',
  'negociated': 'bg-(--uizz-antd-color-success)',
  'refunded': 'bg-(--uizz-antd-color-error)',
  'waiting_refund': 'bg-(--uizz-antd-color-error)',
  'canceled': 'bg-(--uizz-antd-color-error)',
  'duplicated': 'bg-(--uizz-antd-color-error)',
  'expired': 'bg-(--uizz-antd-color-error)',
  'open': 'bg-(--uizz-antd-color-info)',
  'analysing': 'bg-(--uizz-antd-color-info)',
  'recovering': 'bg-(--uizz-antd-color-warning)',
  'waiting_payment': 'bg-(--uizz-antd-color-warning)',
  'scheduled': 'bg-(--uizz-antd-color-warning)'
};

export const TABLE_STATUS_BASE = 'absolute top-0 left-0 z-1 h-full w-2.5 rounded-l-md p-0';

export function getStatusColor(status: string): string {
  return STATUS_COLORS[status] ?? '';
}
